var codeblock_default = {
  "blockStyleSpacing": "h83G6",
  "codeBlock": "dhNXv h83G6",
  "renderedInTable": "IIn9I"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
